import { treadDepthTone, type TreadDepthThresholds, type TreadDepthTone } from 'noddi-util';
import { WheelSetStatus, WheelSetStatusType } from './types';

const TONE_STATUS: Record<TreadDepthTone, WheelSetStatusType> = {
  good: WheelSetStatus.Satisfactory,
  soon: WheelSetStatus.SoonWornOut,
  worn: WheelSetStatus.WornOut
};

export const treadDepthWheelSetStatus = (valueMm: number, thresholds: TreadDepthThresholds): WheelSetStatusType =>
  TONE_STATUS[treadDepthTone(valueMm, thresholds)];

export const getOverallWheelSetStatus = (statuses: WheelSetStatusType[]): WheelSetStatusType => {
  if (statuses.includes(WheelSetStatus.WornOut)) {
    return WheelSetStatus.WornOut;
  }
  if (statuses.includes(WheelSetStatus.SoonWornOut)) {
    return WheelSetStatus.SoonWornOut;
  }
  if (statuses.includes(WheelSetStatus.MissingMeasurements)) {
    return WheelSetStatus.MissingMeasurements;
  }
  return WheelSetStatus.Satisfactory;
};
